import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import * as React from 'react';
import { Trip } from '.';
import DrivingBreakPopup from './DrivingBreakPopup';

const ETACell = (props: GridCustomCellProps) => {
  const [showDrivingBreakPopup, setShowDrivingBreakPopup] = React.useState(false);
  const data = props.dataItem as Trip;
  const drivingBreakComment = data.DrivingBreakComment?.trim();

  const isOpenEndedResumeTime = (resumeDrivingDateTime?: string | Date | null) => {
    if (!resumeDrivingDateTime) return false;

    const resumeDate = dayjs.utc(resumeDrivingDateTime);

    return resumeDate.isValid() && resumeDate.year() === 2999;
  };

  const resumeDrivingLabel = data.ResumeDrivingDateTime
    ? isOpenEndedResumeTime(data.ResumeDrivingDateTime)
      ? 'UNKNOWN'
      : dayjs.utc(data.ResumeDrivingDateTime).tz("America/New_York").format('MM/DD HH:mm')
    : '';

  return (
    <td {...props.tdProps}>
      {showDrivingBreakPopup && <DrivingBreakPopup
        tripId={data.TripID}
        onClose={() => setShowDrivingBreakPopup(false)}
      />}
      {data.ETADateTime && <span style={{ color: data.IsRunningLate ? 'red' : undefined }}>
        {dayjs.utc(data.ETADateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm')}
      </span>}
      <br />
      <span
        style={{ cursor: 'pointer' }}
        className={data.ResumeDrivingDateTime ? "badge badge-danger" : "badge badge-light"}
        title={data.ResumeDrivingDateTime && drivingBreakComment ? drivingBreakComment : undefined}
        onClick={() => setShowDrivingBreakPopup(true)}
      >
        {data.ResumeDrivingDateTime
          ? ((data.DrivingBreakDoNotDisturb ? 'DND: ' : 'DB: ') + resumeDrivingLabel)
          : "Add Break"}
      </span>
    </td>
  );
}

export default React.memo(ETACell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);